import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { bankReconciliation as rules } from 'further-ui/validations';

type Props = {
  children: React.ReactNode;
};

const FormWrapper: React.FC<Props> = ({ children }) => {
  const formMethods = useForm<rules.ReconcileFormValues>({
    resolver: zodResolver(rules.ReconcileFormSchema),
    criteriaMode: 'all',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
